import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GeneratePriceComponent } from './generate-price.component';
import { HeaderModule } from 'src/app/components/header/header.module';
import { HeaderInSectionModule } from 'src/app/components/header-in-section/header-in-section.module';
import { MenuModule } from 'src/app/components/menu/menu.module';
import { BodyGeneratePriceModule } from './body-generate-price/body-generate-price.module';
import { ModalModule } from 'src/app/components/dialogs/modal.module';
import { LoadingLottieModule } from 'src/app/components/loading/loading.module';

@NgModule({
  declarations: [
    GeneratePriceComponent
  ],
  imports: [
    CommonModule,
    HeaderModule,
    HeaderInSectionModule,
    MenuModule,
    BodyGeneratePriceModule,
    ModalModule,
    LoadingLottieModule
  ], exports: [
    GeneratePriceComponent
  ]
})
export class GeneratePriceModule { }
